<template>
  <div
    data-qa="lpu-not-working-alert"
    class="lpu-not-working-label d-flex align-start rounded-sm"
  >
    <span
      class="lpu-not-working-label__icon ui-icon-circle-warning"
      aria-hidden="true"
    />
    <div class="lpu-not-working-label__text text-body-2 text--text py-2 pl-2 pr-4">
      {{ lpuWorkingText }}
    </div>
  </div>
</template>

<script lang="ts" setup>
/**
 * Предупреждение, что клиника сейчас закрыта и когда откроется.
 */
defineProps<{
  lpuWorkingText: string
}>()
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';

.lpu-not-working-label {
  background-color: rgba($ui-kit-text-warning, 0.12);
  border-left: 6px solid rgba($ui-kit-text-warning, 0.4);

  &__icon {
    margin: 6px 6px 6px 10px;
    color: $ui-kit-text-warning;
  }
}
</style>
